import React from 'react';
import { H4 } from 'components/typography';
import { AddAttachment } from 'components';
import { useTranslation } from 'react-i18next';
import { ServiceRequest } from 'graphql-query-contracts';
import { useServiceRequestAttachmentAccess } from 'react-hooks';
import {
  AttachmentDocumentContentTypeEnum,
  AttachmentImageContentTypeEnum,
  AttachmentVariantEnum,
} from 'lane-shared/types/attachment';
import { ContentTypeEnum } from 'constants-content';
import { AmazonS3Buckets } from 'lane-shared/config';
import styles from '../Details.scss';

interface ServiceRequestAttachmentsProps {
  serviceRequest: ServiceRequest;
  attachmentRefId: string;
  hasAttachFilesPermission: boolean;
  isStaffUser: boolean;
  className?: string;
}

export function ServiceRequestAttachments({
  serviceRequest,
  attachmentRefId,
  hasAttachFilesPermission,
  isStaffUser,
  className,
}: ServiceRequestAttachmentsProps) {
  const { t } = useTranslation();
  const { canRead, canCreate, canDelete } =
    useServiceRequestAttachmentAccess(serviceRequest);

  if (!canRead) return null;

  return (
    <div className={className}>
      <H4 mb={2}>{t('web.admin.serviceRequest.attachment.heading')}</H4>
      {hasAttachFilesPermission && (
        <span className={styles.ServiceRequestAttachmentsDisclaimer}>
          {t('web.admin.serviceRequest.attachment.disclaimer')}
        </span>
      )}
      <AddAttachment
        entityId={attachmentRefId}
        entityType={ContentTypeEnum.WorkOrder}
        editMode={false}
        variant={AttachmentVariantEnum.WorkOrder}
        preventDelete={isStaffUser || !canDelete}
        canAddAttachments={hasAttachFilesPermission && canCreate}
        acceptedFileTypes={[
          ...Object.values(AttachmentImageContentTypeEnum),
          AttachmentDocumentContentTypeEnum.pdf,
        ]}
        s3Bucket={AmazonS3Buckets.Activate}
      />
    </div>
  );
}
